export const getFooterLink = () => {
  const source = location.hostname;
  const params = new URLSearchParams({
    utm_source: source,
    utm_medium: "website",
    utm_campaign: "web_widget",
  });
  const footerLink = `https://aichat.com?${params.toString()}`;
  return footerLink;
};
